import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { applyResolvedTheme } from '@/utils/theme';

// The member-facing portal has no theme toggle and is only designed for dark mode, so it always
// forces dark regardless of the staff app's theme setting or the device's OS preference. Applied
// as a side effect in its own leaf component so it doesn't cascade re-renders into the routed
// page tree below.
function ThemeSync() {
  useEffect(() => {
    // Pinned to the classic style: the portal has no picker, so it shouldn't
    // inherit whatever a staff user happened to choose in Dugout.
    applyResolvedTheme('dark', 'classic');
  }, []);
  return null;
}

const Root = () => {
  return (
    <div>
      <ThemeSync />
      {/* <EnvBanner env={membersContext.env} /> */}
      <div className="dark:bg-uniform-gray-900 light:bg-uniform-white-base dark:text-uniform-white-base light:text-uniform-gray-900 font-roboto ">
        <Outlet />
      </div>
    </div>
  );
};

export default Root;
